import React, {Component} from 'react';
import PropTypes from 'prop-types';

import VScroll from 'src/core/gd-components/scrolling/custom-v-scroll/v-scroll';
import SearchInput from "core/gd-ui/search/search";

import Classes from 'classnames';
import _ from 'lodash'
import GDLoadingBlock from "../../../../gd-components/loading/gd-loading-overlap/block/gd-loading-block";
import ApiIntegrationGithub from "../../../../gd/api/integrations/github";
import ApiIntegrationGitlab from "../../../../gd/api/integrations/gitlab";

export default class GitSelectBranchGithub extends React.Component {

    static propTypes = {
        repositories: PropTypes.array,
        repository  : PropTypes.any,

        onClick: PropTypes.func,
        onSelectBranch: PropTypes.func,
    }

    constructor(props) {
        super(props);

        this.state = {
            isLoading       : true,
            searchString    : '',
            branches        : []
        }

        const request = ApiIntegrationGithub.getBranches(this.props.repository.repositoryId)

        request.done(response=>{
            this.setState({
                isLoading: false,
                branches: response
            })
        });

    }



    onSearchChange = (searchString) => {
        this.setState({
            searchString: searchString
        });
    };

    renderList = () => {
        let branches = this.state.branches

        if (this.state.searchString) {
            const searchString = this.state.searchString.toLowerCase();
            branches = _.filter(branches, b=>b.name.toLowerCase().includes(searchString))
        }

        return (
            <div className="list">
                {branches.map((branch) =>(
                    <div key={branch.id} className="list-item repository" onClick={() => this.props.onSelectBranch(branch)}>
                        <div className={Classes('icon', 'i5-git-branch')}/>
                        <div className="label">{branch.name}</div>
                    </div>
                ))}
            </div>
        )
    };

    render() {
        return (
            <div className="main" >

                {this.state.isLoading && <GDLoadingBlock /> }

                <div className="search">
                    <SearchInput onChange={this.onSearchChange} value={this.state.searchString} />
                </div>

                <VScroll containerClass="main-container">
                    {!this.state.isLoading && this.renderList()}
                </VScroll>
            </div>
        );
    }
}
